import Modal from 'extensions/modal';

export default class MiniBasketUpsell {

	constructor (pageContext) {
		this.pageContext = pageContext;
	}

	async init () {
		const minibasketUpsellWrapper = document.getElementById('js-minibasket-upsell-wrapper');

		if (!minibasketUpsellWrapper) {
			return;
		}

		// If the placeholder is NOT there, then it's been filled out.
		if (!minibasketUpsellWrapper.querySelector('.minibasket-upsell-wrapper-placeholder')) {
			this.initModal();
			return;
		}

		minibasketUpsellWrapper.style.minHeight = `${minibasketUpsellWrapper.clientHeight}px`;

		const request = await fetch(`${this.pageContext.Japi_Url}`, {
			body: JSON.stringify({
				currentScreen: this.pageContext.Screen,
				function: 'upsell_carousel',
				productCode: this.pageContext.Product_Code
			}),
			method: 'POST'
		});

		if (!request.ok) {
			return;
		}

		const response = await request.json();

		if (!response?.data) {
			minibasketUpsellWrapper.innerHTML = '';
			return;
		}

		minibasketUpsellWrapper.style.minHeight = `${minibasketUpsellWrapper.clientHeight}px`;
		minibasketUpsellWrapper.innerHTML = response.data;

		this.initModal();
	}

	initModal () {
		const modal = new Modal();
		modal.init();
	}

}
